module.exports = "<div class=\"window-report\">\n    <div layout=\"column\">\n        <div class=\"no-rows\" ng-if=\"!vm.gridOptions.data.length\">\n            <div class=\"msg\">\n                <h3>{{ 'NO_DATA' | translate }}</h3>\n                <i class=\"fa fa-frown-o fa-lg\"></i>\n            </div>\n        </div>\n        <div id=\"grid\" ui-grid=\"vm.gridOptions\" class=\"grid\" ui-grid-resize-columns ui-grid-move-columns></div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/reports/report-summrize/reportData/reportData.tpl.html
// module id = 1831
// module chunks = 0